<template>
  <div class="main-wrapper">
    <Header :show-link="false" :show-nav="false" />
    <div class="register-container">
      <div class="content-title">用户注册</div>
      <el-card class="register-card">
        <div>
          <i class="el-icon-success register-success-icon" />
        </div>
        <br>
        <div class="info-text">感谢您注册多利网经销商用户，我们会在48小时内完成注册信息审核并通知您审核结果。</div>
        <br>
        <p>
          <el-button class="large-button" @click="backHome">返 回 首 页</el-button>
        </p>
      </el-card>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from './layout/components/header'
import Footer from './layout/components/footer'
export default {
  name: 'RegisterResult',
  components: {
    Header,
    Footer
  },
  methods: {
    backHome() {
      this.$router.replace('/home')
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  width: 800px;

  margin: 0px auto 40px auto;
  .register-card {
    padding: 40px 20px;
    min-height: 200px;
    text-align: center;

    .register-success-icon {
      font-size: 60px;
      color: #07c160;
      margin: 10px;
    }
    .info-text {
      width: 400px;
      margin: 10px auto;
      font-size: 16px;
      line-height: 24px;
    }
  }

}
</style>
